import React, { useState, useEffect, useContext, useCallback } from "react";
import { TranslatorContext } from "../../../context/Translator";
import axios from "axios";
import { AnchorComponent, ButtonComponent } from "../../../components/elements";
import { Modal, Row, Col, Form, Table } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import { Link } from "react-router-dom";
import '../App/modalstyle.css';

export default function PaymentMethodsIndex() {
    const { t } = useContext(TranslatorContext);
    const API_BASE = `${process.env.REACT_APP_API_URL}/admin/banks`;
    const authHeaders = { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } };

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [actionLoading, setActionLoading] = useState(false);

    const [alertModal, setAlertModal] = useState(false);
    const [formModal, setFormModal] = useState(false);

    const [currentId, setCurrentId] = useState(null);
    const [formData, setFormData] = useState({ name: "", account_no: "" });
    const [errors, setErrors] = useState({});

    const fetchPaymentMethods = useCallback(async () => {
        setLoading(true);
        try {
            const res = await axios.get(API_BASE, authHeaders);
            setData(res.data?.data || res.data || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, [API_BASE]);

    useEffect(() => {
        fetchPaymentMethods();
    }, [fetchPaymentMethods]);

    const openModal = (item = null) => {
        setErrors({});
        if (item) {
            setCurrentId(item.id);
            setFormData({ name: item.name || "", account_no: item.account_no || "" });
        } else {
            setCurrentId(null);
            setFormData({ name: "", account_no: "" });
        }
        setFormModal(true);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setActionLoading(true);
        setErrors({});

        try {
            const url = currentId ? `${process.env.REACT_APP_API_URL}/admin/banks/${currentId}` : API_BASE;
            const res = await axios.put(url, formData, authHeaders);

            if (res.data?.success || res.status === 200 || res.status === 201) {
                fetchPaymentMethods();
                setFormModal(false);
            }
        } catch (err) {
            if (err.response?.status === 422) {
                setErrors(err.response.data.errors || {});
            } else {
                console.error("Submit Error:", err);
            }
        } finally {
            setActionLoading(false);
        }
    };

    const handleDelete = async () => {
        if (!currentId) return;
        setActionLoading(true);
        try {
            await axios.delete(`${API_BASE}/${currentId}`, authHeaders);
            fetchPaymentMethods();
            setAlertModal(false);
        } catch (err) {
            console.error("Delete Error:", err);
        } finally {
            setActionLoading(false);
            setCurrentId(null);
        }
    };

    if (loading) return <PageLayout><p>{t("loading")}...</p></PageLayout>;

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-breadcrumb">
                            <h3 className="mc-breadcrumb-title">{t("payment methods")}</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item">
                                    <Link to="#" className="mc-breadcrumb-link">{t("home")}</Link>
                                </li>
                                <li className="mc-breadcrumb-item">
                                    <Link to="#" className="mc-breadcrumb-link">{t("payment methods")}</Link>
                                </li>
                                <li className="mc-breadcrumb-item">{t("list")}</li>
                            </ul>
                        </div>
                    </div>
                </Col>

                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-card-header d-flex justify-content-between align-items-center p-3">
                            <h5 className="mc-card-title mb-0">{t("payment methods list")}</h5>
                            <ButtonComponent
                                type="button"
                                className="btn btn-primary d-flex align-items-center"
                                onClick={() => openModal()}
                            >
                                <i className="material-icons me-1">add</i>
                                {t("add Payment Method")}
                            </ButtonComponent>
                        </div>

                        <Row>
                            <Col xl={12}>
                                <div className="mc-card">
                                    <div className="table-responsive-wrapper">
                                        <Table responsive className="table mb-0">
                                            <thead>
                                                <tr>
                                                    <th><div className="mc-table-check"><p>#</p></div></th>
                                                    <th>{t("name")}</th>
                                                    <th>{t("account_no")}</th>
                                                    <th>{t("actions")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.map((item, index) => (
                                                    <tr key={item.id || index}>
                                                        <td><div className="mc-table-check"><p>{index + 1}</p></div></td>
                                                        <td>{item.name}</td>
                                                        <td>{item.account_no || "-"}</td>
                                                        <td>
                                                            <div className="mc-table-action">
                                                                <ButtonComponent
                                                                    type="button"
                                                                    className="material-icons edit me-2"
                                                                    onClick={() => openModal(item)}
                                                                    title="Edit"
                                                                >
                                                                    edit
                                                                </ButtonComponent>
                                                                <ButtonComponent
                                                                    type="button"
                                                                    className="material-icons delete"
                                                                    onClick={() => {
                                                                        setCurrentId(item.id);
                                                                        setAlertModal(true);
                                                                    }}
                                                                    title="Delete"
                                                                >
                                                                    delete
                                                                </ButtonComponent>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>

            {/* Combined Create/Edit Modal */}
            <Modal show={formModal} onHide={() => setFormModal(false)} centered dialogClassName="custom-modal-dialog" contentClassName="custom-modal-content">
                <Modal.Header closeButton className="p-3">
                    <Modal.Title>{currentId ? t("edit payment method") : t("add payment method")}</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>{t("name")} <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                isInvalid={!!errors.name}
                                placeholder="Enter Name"
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.name?.[0]}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>{t("account number")}</Form.Label>
                            <Form.Control
                                type="text"
                                name="account_no"
                                value={formData.account_no}
                                onChange={handleChange}
                                isInvalid={!!errors.account_no}
                                placeholder="Enter account number"
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.account_no?.[0]}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer className="p-2">
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={() => setFormModal(false)}>
                            {t("cancel")}
                        </ButtonComponent>
                        <ButtonComponent type="submit" className="btn btn-primary" disabled={actionLoading}>
                            {actionLoading && <span className="spinner-border spinner-border-sm me-2"></span>}
                            {currentId ? t("update") : t("save")}
                        </ButtonComponent>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal show={alertModal} onHide={() => setAlertModal(false)} centered>
                <div className="mc-alert-modal p-4 text-center">
                    <i className="material-icons" style={{ fontSize: "50px", color: "red" }}>new_releases</i>
                    <h3 className="mt-3">{t("Are you sure?")}</h3>
                    <p>{t("Want to delete this payment method?")}</p>
                    <div className="d-flex justify-content-center gap-2 mt-3">
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={() => setAlertModal(false)}>
                            {t("close")}
                        </ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-danger" onClick={handleDelete} disabled={actionLoading}>
                            {actionLoading ? <span className="spinner-border spinner-border-sm me-2"></span> : t("delete")}
                        </ButtonComponent>
                    </div>
                </div>
            </Modal>
        </PageLayout>
    );
}